import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <DModal
  class="feature-topic"
  @title={{i18n "topic.feature_topic.title"}}
  @closeModal={{@closeModal}}
>
  <:body>
    {{#if @model.topic.pinned_at}}
      <div class="feature-section">
        <div class="desc">
          {{#if @model.topic.pinned_globally}}
            <p>
              <ConditionalLoadingSpinner
                @size="small"
                @condition={{this.loading}}
              >
                {{#if this.pinnedGloballyCount}}
                  {{html-safe
                    (i18n
                      "topic.feature_topic.already_pinned_globally"
                      count=this.pinnedGloballyCount
                    )
                  }}
                {{else}}
                  {{html-safe (i18n "topic.feature_topic.not_pinned_globally")}}
                {{/if}}
              </ConditionalLoadingSpinner>
            </p>
            <p>{{i18n "topic.feature_topic.global_pin_note"}}</p>
          {{else}}
            <p>
              <ConditionalLoadingSpinner
                @size="small"
                @condition={{this.loading}}
              >
                {{html-safe this.alreadyPinnedMessage}}
              </ConditionalLoadingSpinner>
            </p>
            <p>{{i18n "topic.feature_topic.pin_note"}}</p>
          {{/if}}
          <p>{{html-safe this.unPinMessage}}</p>
          <p><DButton
              @action={{this.unpin}}
              @icon="thumbtack"
              @label="topic.feature.unpin"
              class="btn-primary"
            /></p>
        </div>
      </div>
    {{else}}
      <div class="feature-section">
        <div class="desc">
          <p>
            <ConditionalLoadingSpinner
              @size="small"
              @condition={{this.loading}}
            >
              {{html-safe this.alreadyPinnedMessage}}
            </ConditionalLoadingSpinner>
          </p>
          <p>
            {{i18n "topic.feature_topic.pin_note"}}
          </p>
          {{#if this.site.isMobileDevice}}
            <p>
              {{html-safe this.pinMessage}}
            </p>
            <p class="with-validation">
              <FutureDateInput
                class="pin-until"
                @clearable={{true}}
                @input={{@model.topic.pinnedInCategoryUntil}}
                @onChangeInput={{action
                  (mut @model.topic.pinnedInCategoryUntil)
                }}
              />
              <PopupInputTip
                @validation={{this.pinInCategoryValidation}}
                @shownAt={{this.pinInCategoryTipShownAt}}
              />
            </p>
          {{else}}
            <p class="with-validation">
              {{html-safe this.pinMessage}}
              <span>
                {{d-icon "far-clock"}}
                <FutureDateInput
                  class="pin-until"
                  @clearable={{true}}
                  @input={{@model.topic.pinnedInCategoryUntil}}
                  @onChangeInput={{action
                    (mut @model.topic.pinnedInCategoryUntil)
                  }}
                />
                <PopupInputTip
                  @validation={{this.pinInCategoryValidation}}
                  @shownAt={{this.pinInCategoryTipShownAt}}
                />
              </span>
            </p>
          {{/if}}
          <p>
            <DButton
              @action={{this.pin}}
              @icon="thumbtack"
              @label="topic.feature.pin"
              class="btn-primary"
            />
          </p>
        </div>
      </div>
      {{#if this.canPinGlobally}}
        <hr />
        <div class="feature-section">
          <div class="desc">
            <p>
              <ConditionalLoadingSpinner
                @size="small"
                @condition={{this.loading}}
              >
                {{#if this.pinnedGloballyCount}}
                  {{html-safe
                    (i18n
                      "topic.feature_topic.already_pinned_globally"
                      count=this.pinnedGloballyCount
                    )
                  }}
                {{else}}
                  {{html-safe (i18n "topic.feature_topic.not_pinned_globally")}}
                {{/if}}
              </ConditionalLoadingSpinner>
            </p>
            <p>
              {{i18n "topic.feature_topic.global_pin_note"}}
            </p>
            {{#if this.site.isMobileDevice}}
              <p>
                {{i18n "topic.feature_topic.pin_globally"}}
              </p>
              <p class="with-validation">
                <FutureDateInput
                  class="pin-until"
                  @clearable={{true}}
                  @input={{@model.topic.pinnedGloballyUntil}}
                  @onChangeInput={{action
                    (mut @model.topic.pinnedGloballyUntil)
                  }}
                />
                <PopupInputTip
                  @validation={{this.pinGloballyValidation}}
                  @shownAt={{this.pinGloballyTipShownAt}}
                />
              </p>
            {{else}}
              <p class="with-validation">
                {{i18n "topic.feature_topic.pin_globally"}}
                <span>
                  {{d-icon "far-clock"}}
                  <FutureDateInput
                    class="pin-until"
                    @clearable={{true}}
                    @input={{@model.topic.pinnedGloballyUntil}}
                    @onChangeInput={{action
                      (mut @model.topic.pinnedGloballyUntil)
                    }}
                  />
                  <PopupInputTip
                    @validation={{this.pinGloballyValidation}}
                    @shownAt={{this.pinGloballyTipShownAt}}
                  />
                </span>
              </p>
            {{/if}}
            <p>
              <DButton
                @action={{this.pinGlobally}}
                @icon="thumbtack"
                @label="topic.feature.pin_globally"
                class="btn-primary"
              />
            </p>
          </div>
        </div>
      {{/if}}
    {{/if}}
    <hr />
    {{#if this.currentUser.staff}}
      <div class="feature-section">
        <div class="desc">
          <p>
            <ConditionalLoadingSpinner
              @size="small"
              @condition={{this.loading}}
            >
              {{#if this.bannerCount}}
                {{html-safe (i18n "topic.feature_topic.banner_exists")}}
              {{else}}
                {{html-safe (i18n "topic.feature_topic.no_banner_exists")}}
              {{/if}}
            </ConditionalLoadingSpinner>
          </p>
          <p>
            {{i18n "topic.feature_topic.banner_note"}}
          </p>
          <p>
            {{#if @model.topic.isBanner}}
              {{i18n "topic.feature_topic.remove_banner"}}
            {{else}}
              {{i18n "topic.feature_topic.make_banner"}}
            {{/if}}
          </p>
          <p>
            {{#if @model.topic.isBanner}}
              <DButton
                @action={{this.removeBanner}}
                @icon="thumbtack"
                @label="topic.feature.remove_banner"
                class="btn-primary"
              />
            {{else}}
              <DButton
                @action={{this.makeBanner}}
                @icon="thumbtack"
                @label="topic.feature.make_banner"
                class="btn-primary make-banner"
              />
            {{/if}}
          </p>
        </div>
      </div>
    {{/if}}
  </:body>
</DModal>
*/
{
  "id": "1yu4kcOe",
  "block": "[[[8,[39,0],[[24,0,\"feature-topic\"]],[[\"@title\",\"@closeModal\"],[[28,[37,1],[\"topic.feature_topic.title\"],null],[30,1]]],[[\"body\"],[[[[1,\"\\n\"],[41,[30,2,[\"topic\",\"pinned_at\"]],[[[1,\"      \"],[10,0],[14,0,\"feature-section\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"desc\"],[12],[1,\"\\n\"],[41,[30,2,[\"topic\",\"pinned_globally\"]],[[[1,\"            \"],[10,2],[12],[1,\"\\n              \"],[8,[39,3],null,[[\"@size\",\"@condition\"],[\"small\",[30,0,[\"loading\"]]]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"pinnedGloballyCount\"]],[[[1,\"                  \"],[1,[28,[35,4],[[28,[37,1],[\"topic.feature_topic.already_pinned_globally\"],[[\"count\"],[[30,0,[\"pinnedGloballyCount\"]]]]]],null]],[1,\"\\n\"]],[]],[[[1,\"                  \"],[1,[28,[35,4],[[28,[37,1],[\"topic.feature_topic.not_pinned_globally\"],null]],null]],[1,\"\\n\"]],[]]],[1,\"              \"]],[]]]]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,2],[12],[1,[28,[35,1],[\"topic.feature_topic.global_pin_note\"],null]],[13],[1,\"\\n\"]],[]],[[[1,\"            \"],[10,2],[12],[1,\"\\n              \"],[8,[39,3],null,[[\"@size\",\"@condition\"],[\"small\",[30,0,[\"loading\"]]]],[[\"default\"],[[[[1,\"\\n                \"],[1,[28,[35,4],[[30,0,[\"alreadyPinnedMessage\"]]],null]],[1,\"\\n              \"]],[]]]]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,2],[12],[1,[28,[35,1],[\"topic.feature_topic.pin_note\"],null]],[13],[1,\"\\n\"]],[]]],[1,\"          \"],[10,2],[12],[1,[28,[35,4],[[30,0,[\"unPinMessage\"]]],null]],[13],[1,\"\\n          \"],[10,2],[12],[8,[39,5],[[24,0,\"btn-primary\"]],[[\"@action\",\"@icon\",\"@label\"],[[30,0,[\"unpin\"]],\"thumbtack\",\"topic.feature.unpin\"]],null],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,0],[14,0,\"feature-section\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"desc\"],[12],[1,\"\\n          \"],[10,2],[12],[1,\"\\n            \"],[8,[39,3],null,[[\"@size\",\"@condition\"],[\"small\",[30,0,[\"loading\"]]]],[[\"default\"],[[[[1,\"\\n              \"],[1,[28,[35,4],[[30,0,[\"alreadyPinnedMessage\"]]],null]],[1,\"\\n            \"]],[]]]]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,2],[12],[1,\"\\n            \"],[1,[28,[35,1],[\"topic.feature_topic.pin_note\"],null]],[1,\"\\n          \"],[13],[1,\"\\n\"],[41,[30,0,[\"site\",\"isMobileDevice\"]],[[[1,\"            \"],[10,2],[12],[1,\"\\n              \"],[1,[28,[35,4],[[30,0,[\"pinMessage\"]]],null]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,2],[14,0,\"with-validation\"],[12],[1,\"\\n              \"],[8,[39,6],[[24,0,\"pin-until\"]],[[\"@clearable\",\"@input\",\"@onChangeInput\"],[true,[30,2,[\"topic\",\"pinnedInCategoryUntil\"]],[28,[37,7],[[30,0],[28,[37,8],[[30,2,[\"topic\",\"pinnedInCategoryUntil\"]]],null]],null]]],null],[1,\"\\n              \"],[8,[39,9],null,[[\"@validation\",\"@shownAt\"],[[30,0,[\"pinInCategoryValidation\"]],[30,0,[\"pinInCategoryTipShownAt\"]]]],null],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],[[[1,\"            \"],[10,2],[14,0,\"with-validation\"],[12],[1,\"\\n              \"],[1,[28,[35,4],[[30,0,[\"pinMessage\"]]],null]],[1,\"\\n              \"],[10,1],[12],[1,\"\\n                \"],[1,[28,[35,10],[\"far-clock\"],null]],[1,\"\\n                \"],[8,[39,6],[[24,0,\"pin-until\"]],[[\"@clearable\",\"@input\",\"@onChangeInput\"],[true,[30,2,[\"topic\",\"pinnedInCategoryUntil\"]],[28,[37,7],[[30,0],[28,[37,8],[[30,2,[\"topic\",\"pinnedInCategoryUntil\"]]],null]],null]]],null],[1,\"\\n                \"],[8,[39,9],null,[[\"@validation\",\"@shownAt\"],[[30,0,[\"pinInCategoryValidation\"]],[30,0,[\"pinInCategoryTipShownAt\"]]]],null],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]]],[1,\"          \"],[10,2],[12],[1,\"\\n            \"],[8,[39,5],[[24,0,\"btn-primary\"]],[[\"@action\",\"@icon\",\"@label\"],[[30,0,[\"pin\"]],\"thumbtack\",\"topic.feature.pin\"]],null],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"],[41,[30,0,[\"canPinGlobally\"]],[[[1,\"        \"],[10,\"hr\"],[12],[13],[1,\"\\n        \"],[10,0],[14,0,\"feature-section\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"desc\"],[12],[1,\"\\n            \"],[10,2],[12],[1,\"\\n              \"],[8,[39,3],null,[[\"@size\",\"@condition\"],[\"small\",[30,0,[\"loading\"]]]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"pinnedGloballyCount\"]],[[[1,\"                  \"],[1,[28,[35,4],[[28,[37,1],[\"topic.feature_topic.already_pinned_globally\"],[[\"count\"],[[30,0,[\"pinnedGloballyCount\"]]]]]],null]],[1,\"\\n\"]],[]],[[[1,\"                  \"],[1,[28,[35,4],[[28,[37,1],[\"topic.feature_topic.not_pinned_globally\"],null]],null]],[1,\"\\n\"]],[]]],[1,\"              \"]],[]]]]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,2],[12],[1,\"\\n              \"],[1,[28,[35,1],[\"topic.feature_topic.global_pin_note\"],null]],[1,\"\\n            \"],[13],[1,\"\\n\"],[41,[30,0,[\"site\",\"isMobileDevice\"]],[[[1,\"              \"],[10,2],[12],[1,\"\\n                \"],[1,[28,[35,1],[\"topic.feature_topic.pin_globally\"],null]],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,2],[14,0,\"with-validation\"],[12],[1,\"\\n                \"],[8,[39,6],[[24,0,\"pin-until\"]],[[\"@clearable\",\"@input\",\"@onChangeInput\"],[true,[30,2,[\"topic\",\"pinnedGloballyUntil\"]],[28,[37,7],[[30,0],[28,[37,8],[[30,2,[\"topic\",\"pinnedGloballyUntil\"]]],null]],null]]],null],[1,\"\\n                \"],[8,[39,9],null,[[\"@validation\",\"@shownAt\"],[[30,0,[\"pinGloballyValidation\"]],[30,0,[\"pinGloballyTipShownAt\"]]]],null],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],[[[1,\"              \"],[10,2],[14,0,\"with-validation\"],[12],[1,\"\\n                \"],[1,[28,[35,1],[\"topic.feature_topic.pin_globally\"],null]],[1,\"\\n                \"],[10,1],[12],[1,\"\\n                  \"],[1,[28,[35,10],[\"far-clock\"],null]],[1,\"\\n                  \"],[8,[39,6],[[24,0,\"pin-until\"]],[[\"@clearable\",\"@input\",\"@onChangeInput\"],[true,[30,2,[\"topic\",\"pinnedGloballyUntil\"]],[28,[37,7],[[30,0],[28,[37,8],[[30,2,[\"topic\",\"pinnedGloballyUntil\"]]],null]],null]]],null],[1,\"\\n                  \"],[8,[39,9],null,[[\"@validation\",\"@shownAt\"],[[30,0,[\"pinGloballyValidation\"]],[30,0,[\"pinGloballyTipShownAt\"]]]],null],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]]],[1,\"            \"],[10,2],[12],[1,\"\\n              \"],[8,[39,5],[[24,0,\"btn-primary\"]],[[\"@action\",\"@icon\",\"@label\"],[[30,0,[\"pinGlobally\"]],\"thumbtack\",\"topic.feature.pin_globally\"]],null],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null]],[]]],[1,\"    \"],[10,\"hr\"],[12],[13],[1,\"\\n\"],[41,[30,0,[\"currentUser\",\"staff\"]],[[[1,\"      \"],[10,0],[14,0,\"feature-section\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"desc\"],[12],[1,\"\\n          \"],[10,2],[12],[1,\"\\n            \"],[8,[39,3],null,[[\"@size\",\"@condition\"],[\"small\",[30,0,[\"loading\"]]]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"bannerCount\"]],[[[1,\"                \"],[1,[28,[35,4],[[28,[37,1],[\"topic.feature_topic.banner_exists\"],null]],null]],[1,\"\\n\"]],[]],[[[1,\"                \"],[1,[28,[35,4],[[28,[37,1],[\"topic.feature_topic.no_banner_exists\"],null]],null]],[1,\"\\n\"]],[]]],[1,\"            \"]],[]]]]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,2],[12],[1,\"\\n            \"],[1,[28,[35,1],[\"topic.feature_topic.banner_note\"],null]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,2],[12],[1,\"\\n\"],[41,[30,2,[\"topic\",\"isBanner\"]],[[[1,\"              \"],[1,[28,[35,1],[\"topic.feature_topic.remove_banner\"],null]],[1,\"\\n\"]],[]],[[[1,\"              \"],[1,[28,[35,1],[\"topic.feature_topic.make_banner\"],null]],[1,\"\\n\"]],[]]],[1,\"          \"],[13],[1,\"\\n          \"],[10,2],[12],[1,\"\\n\"],[41,[30,2,[\"topic\",\"isBanner\"]],[[[1,\"              \"],[8,[39,5],[[24,0,\"btn-primary\"]],[[\"@action\",\"@icon\",\"@label\"],[[30,0,[\"removeBanner\"]],\"thumbtack\",\"topic.feature.remove_banner\"]],null],[1,\"\\n\"]],[]],[[[1,\"              \"],[8,[39,5],[[24,0,\"btn-primary make-banner\"]],[[\"@action\",\"@icon\",\"@label\"],[[30,0,[\"makeBanner\"]],\"thumbtack\",\"topic.feature.make_banner\"]],null],[1,\"\\n\"]],[]]],[1,\"          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"]],[]]]]]],[\"@closeModal\",\"@model\"],false,[\"d-modal\",\"i18n\",\"if\",\"conditional-loading-spinner\",\"html-safe\",\"d-button\",\"future-date-input\",\"action\",\"mut\",\"popup-input-tip\",\"d-icon\"]]",
  "moduleName": "discourse/components/modal/feature-topic.hbs",
  "isStrictMode": false
});